import AskModal from 'components/common/AskModal';
import NotiModal from 'components/common/NotiModal';
import useContractViewerPlaceCard from 'hooks/contract/useContractViewerPlaceCard';
import { DeleteBtn } from 'lib/styles/icons';
import { useState } from 'react';
import styled from 'styled-components';

const ContractViewerPlaceCard = ({ store, storeLength }) => {
  const [showAskModal, setShowAskModal] = useState(false);

  const { isLoading, error, reset, onDelete } = useContractViewerPlaceCard(
    store.id,
  );

  if (isLoading) {
    return (
      <div
        style={{ display: 'flex', justifyContent: 'flex-end', marginTop: 4 }}
      >
        Loading...
      </div>
    );
  }
  if (error?.response.status === 500) {
    return (
      <NotiModal
        closeModal={() => reset()}
        msg="서버 오류가 발생했습니다"
        fontL
      />
    );
  }

  return (
    <>
      {showAskModal && (
        <AskModal
          closeModal={() => setShowAskModal(false)}
          action="삭제"
          message="정말로 삭제하시겠습니까?"
          actionFc={() => {
            onDelete();
            setShowAskModal(false);
          }}
        />
      )}
      <ContractViewerPlaceCardBlock>
        <div>
          <div className="place-title">{store.name}</div>
          <div className="place-address">{store.address}</div>
          <div className="place-address">{store.detailAddress}</div>
        </div>
        <DeleteBtn
          className="place-icon"
          onClick={() => {
            if (storeLength === 1) {
              return;
            }
            setShowAskModal(true);
          }}
        />
      </ContractViewerPlaceCardBlock>
    </>
  );
};

export default ContractViewerPlaceCard;

const ContractViewerPlaceCardBlock = styled.div`
  margin-bottom: 8px;
  padding: 15px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-radius: 10px;
  background: rgba(0, 0, 0, 0.08);
`;
